import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

/**
 * useOrderPass — may this account order while a payment clears? (Sky,
 * 2026-10-22.)
 *
 * A customer on credit hold who has just paid by card or bank is let through
 * for ONE order, but only when the payments still clearing cover the whole
 * past-due amount. Once the payment posts the hold lifts in the ordinary way.
 *
 * orders.fn_my_order_pass() takes no argument, so it can only answer for the
 * caller. submit-order asks the same rule (fn_order_pass_for) and is what
 * actually decides — this hook only shapes the screen.
 */
export interface OrderPass {
  past_due: number;
  covered: number;
  first_payment_at: string | null;
  order_cap: number;
  orders_used: number;
  covers_past_due: boolean;
  eligible: boolean;
}

export function useOrderPass(customerId?: string | null) {
  return useQuery<OrderPass | null>({
    queryKey: ['order-pass', customerId ?? null],
    queryFn: async () => {
      const { data, error } = await supabase.schema('orders').rpc('fn_my_order_pass');
      if (error) throw error;
      return (data as OrderPass | null) ?? null;
    },
    staleTime: 30_000,
  });
}
